import { IAddressHook } from '@models';
import { useStore } from '@stores';
import { postodeRegex } from '@utils';
import { useEffect, useState } from 'react';

export const useAddresses = (): IAddressHook => {
  const { addressStore } = useStore();
  const { address } = addressStore;
  const [postcode, setPostcode] = useState<string>();

  useEffect(() => {
    postcode && postodeRegex.test(postcode) && addressStore.getAddress(postcode);

    return () => {
      addressStore.clearAddress();
    };
  }, [addressStore, postcode]);

  return {
    address,
    postcode,
    handleAddressSearch: setPostcode,
    clearAddress: addressStore.clearAddress,
  };
};
